module.exports = __webpack_public_path__ + "Frame390-478ca365.webp";